<template>
  <div class="vx-row flex flex-col">
    <div class="vx-col w-full">
      <vs-card>
        <div slot="header">
          <h3>{{customer.name}}</h3>
        </div>
        <div class="flex flex-col">
          <vs-button
            @click="$router.push({name: 'customers-edit',params:{id: customer.id}})"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-edit"
            class="mb-4 self-end"
            size="medium"
          >Edit Pemohon</vs-button>
          <vs-table :data="[1]">
            <template slot="thead">
              <th style="width: 200px;"></th>
              <th style="width: 20px;"></th>
              <th></th>
            </template>
            <tbody>
              <tr>
                <td>Tipe Identitas</td>
                <td>:</td>
                <td>{{customer.identity_tipe}}</td>
              </tr>
              <tr>
                <td>Nomor Identitas</td>
                <td>:</td>
                <td>{{customer.identity_number}}</td>
              </tr>
              <tr>
                <td>Nama Pemohon</td>
                <td>:</td>
                <td>{{customer.name}}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>:</td>
                <td>{{customer.email}}</td>
              </tr>
              <tr>
                <td>Telepon</td>
                <td>:</td>
                <td>{{customer.phone}}</td>
              </tr>
              <tr>
                <td>Gender</td>
                <td>:</td>
                <td>{{customer.sex}}</td>
              </tr>
              <tr>
                <td>Alamat</td>
                <td>:</td>
                <td>{{customer.address}}</td>
              </tr>
              <tr>
                <td>Status</td>
                <td>:</td>
                <td>
                  <vs-chip v-if="customer.is_active" color="green">Aktif</vs-chip>
                  <vs-chip v-else color="warning">Tidak Aktif</vs-chip>
                </td>
              </tr>
              <tr>
                <td>Is Banned</td>
                <td>:</td>
                <td>
                  <vs-chip v-if="customer.is_ban" color="danger">Banned</vs-chip>
                  <vs-chip v-else color="green">Non Banned</vs-chip>
                </td>
              </tr>
            </tbody>
          </vs-table>
        </div>
      </vs-card>
      <vs-button
        @click="$router.push({name: 'customers'})"
        color="primary"
        type="border"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="mb-4 self-end"
        size="medium"
      >Kembali</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customer : [],
    };
  },
  mounted() {
    this.getCustomer();
  },
  methods: {
    getCustomer() {
      this.$http
      .get(`/app/secure/customer/${this.$route.params.id}/show`)
      .then(r => {
        this.customer = r.data.data.customer;
      })
      .finally(() => {
        this.$vs.loading.close();
      });
    },

  }
};
</script>>